import { Controller } from "@hotwired/stimulus"
import AirDatepicker from "air-datepicker"
import localeDe from "air-datepicker/locale/de"

export default class extends Controller {
  static targets = ["element"]
  static values = {
    startDate: String,
    endDate: String,
    range: Boolean
  }

  // Lifecycle

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) { return }

    this.targetElement.dataset.currentInstance = true
    this.cleanupPreviousInstances()

    this.instance = new AirDatepicker(this.targetElement, this.options)
  }

  disconnect() {
    if (this.instance) { this.instance.destroy() }
  }

  // Actions

  clear() {
    if (!this.instance) { return }

    this.instance.clear()
  }

  cleanupPreviousInstances() {
    const siblings = this.targetElement.parentNode.querySelectorAll("input[type=text]")

    for (let i = 0; i < siblings.length; i++) {
      if (siblings[i].dataset.controller || siblings[i].dataset.currentInstance) { continue }
      siblings[i].remove()
    }

    this.targetElement.type = "text"
  }

  // Getters

  get options() {
    const options = {
      dateFormat: "dd.MM.yyyy",
      locale: localeDe,
      onHide: () => { this.element.dispatchEvent(new Event("change")) }
    }

    if (this.rangeValue) {
      options.range = true
      options.multipleDatesSeparator = " - "
    }

    if (this.hasStartDateValue && this.hasEndDateValue) {
      options.selectedDates = [this.startDateValue, this.endDateValue]
    }

    return options
  }

  get targetElement() {
    if (this.hasElementTarget && this.elementTarget) { return this.elementTarget }

    return this.element
  }
}
